import { Fragment } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
// import styles from "./OurServices.module.scss";
import TestimonialsCard from "./testimonials/TestimonialsCard";
import useScreenSize from "../hooks/useScreenSize";

import image1 from "../assets/images/testimonials/image-1.png"
import image2 from "../assets/images/testimonials/image-2.png"
import image3 from "../assets/images/testimonials/image-3.png"
import image4 from "../assets/images/testimonials/image-4.png"
import image5 from "../assets/images/testimonials/image-5.png"
import image6 from "../assets/images/testimonials/image-6.png"
import image7 from "../assets/images/testimonials/image-7.png"
import image8 from "../assets/images/testimonials/image-8.png"
import image9 from "../assets/images/testimonials/image-9.png"
import image10 from "../assets/images/testimonials/image-10.png"
import image11 from "../assets/images/testimonials/image-11.png"
import image12 from "../assets/images/testimonials/image-12.png"
import image13 from "../assets/images/testimonials/image-13.png"
import image14 from "../assets/images/testimonials/image-14.png"
import image15 from "../assets/images/testimonials/image-15.png"
import image16 from "../assets/images/testimonials/image-16.png"
import useLang from "hooks/useLang";

const createPairs = (inputList) => {
  if (inputList.length % 2 !== 0) {
    inputList.push(null);
  }
  const result = [];
  for (let i = 0; i < inputList.length; i += 2) {
    const pair = inputList.slice(i, i + 2);
    result.push(pair);
  }
  return result;
};

const Testimonials = () => {
  const { width, breakpoints } = useScreenSize();
  const { lang } = useLang()

  return (
    <Fragment>
      <section className={["section bg-section"].join(" ")} id="testimonials">
        <Container>
          <Row>
            <Col lg={12}>
              <div style={{display: "block !important"}} className="sec-hd-custom">
                <h2 className="sec-title">{lang.testimonials.section_title}</h2>
              </div>
              <h1 style={{textAlign: "center"}} className="sec-title">{lang.testimonials.section_detail}</h1>
            </Col>
          </Row>
          <Row>
            <Swiper
              className="hcarousel"
              allowTouchMove={true}
              slidesPerView={width < breakpoints.sm ? 1 : 2}
              spaceBetween={25}
              pagination={true}
              navigation={true}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              loop={true}
              modules={[Autoplay, Navigation, Pagination]}
            >
              {createPairs([
                {
                  rating: 5,
                  img: image1,
                  name: "Ferdiana Rosyada Selly",
                  description: `Trusted dan recommended bgt🤩 …`,
                },
                {
                  rating: 5,
                  img: image2,
                  name: "Melcia Lydia",
                  description: `Very Good`,
                },
                {
                  rating: 5,
                  img: image3,
                  name: "Roland Pardede",
                  description: `top👍 …`,
                },
                {
                  rating: 5,
                  img: image4,
                  name: "Baeti Romaniah",
                  description: `Excellent!! 👍🏻👍🏻 …`,
                },
                {
                  rating: 5,
                  img: image5,
                  name: "Tanggo Wafers",
                  description: `sangat recommended, service yang diberikan sangat friendly namun informatif, mampu memberikan solusi solusi di bidang perpajakan👌🏻 sukses selalu …`,
                },
                {
                  rating: 5,
                  img: image6,
                  name: "Shendy OctariansyahPutra",
                  description: `Sangat membantu urusan perpajakan maupun pengadilan pajak, tax consulting yg berpengalaman dan berlisensi, mengatasi masalah tanpa masalah`,
                },
                {
                  rating: 5,
                  img: image7,
                  name: "Benyamin Yosafat Manurung",
                  description: `Pelayanan sangat memuaskan, tanya pajak perusahaan terjawab dengan baik.`,
                },
                {
                  rating: 5,
                  img: image8,
                  name: "Suryadi Sinaga",
                  description: `Kantornya rapi, pegawai dan Tax Consultannya ramah, advisenya sangat mudah dipahami, Fast Respon dan sangat memahami aturan Perpajakan dalam negeri dan Luar Negeri`,
                },
                {
                  rating: 5,
                  img: image9,
                  name: "Ratna Wahyu",
                  description: `Pelayanannya sangat ramah, sangat membantu dalam hal perpajakan`,
                },
                {
                  rating: 5,
                  img: image10,
                  name: "Tommy Hardianto",
                  description: `Terima kasih untuk team Adinata atas bantuan pengurusan pajak perusahaan saya, senang bisa bekerja sama dengan Adinata`,
                },
                {
                  rating: 5,
                  img: image11,
                  name: "tokutei ginou nippon",
                  description: `めっちゃいい事務所です！この会計事務所は日本人には本当にお勧めしてます👍 …`,
                },
                {
                  rating: 5,
                  img: image12,
                  name: "Dika Fauziah",
                  description: `Sangat membantu, untuk urusan pembukuan dan perpajakan, The best pokonyaa 👍 …`,
                },
                {
                  rating: 5,
                  img: image13,
                  name: "joko nathanael",
                  description: `Salah satu Konsultan Pajak yang berpengalaman di bidangnya, kerjanya cepat, tepat dan dapat dipercaya.
                    Ditambah lagi karyawan dan owner nya ramah” dan asyik juga pembawaannya,
                    Maju terus Adinata Konsultan💪🏻💪🏻 …`,
                },
                {
                  rating: 5,
                  img: image14,
                  name: "Feri Permana",
                  description: `tempatnya bagus sekali worth it`,
                },
                {
                  rating: 5,
                  img: image15,
                  name: "febrianto paturanan",
                  description: `Konsultan pajak yang sangat berpengalaman dan sangat terpercaya
`,
                },
                {
                  rating: 5,
                  img: image16,
                  name: "Imanuel Christian",
                  description: `Tempat nyaman & ada parkiran khususnya untuk kantor ini, Adminnya ramah banget. Top deh bisa terlayani dengan baik.`,
                },
              ]).map(([service1, service2]) => (
                <SwiperSlide>
                  <TestimonialsCard
                    className="mb-4"
                    img={service1.img}
                    rating={service1.rating}
                    name={service1.name}
                    description={service1.description}
                  />
                  {service2 == null ? (
                    <div />
                  ) : (
                    <TestimonialsCard
                      img={service2.img}
                      rating={service2.rating}
                      name={service2.name}
                      description={service2.description}
                    />
                  )}
                </SwiperSlide>
              ))}
            </Swiper>
          </Row>
        </Container>
      </section>
    </Fragment>
  );
};

export default Testimonials;
